import { Provider } from '@angular/core';

import { AuthService, LoginService, UserService } from '@beecore/auth';
import { BC_STARTUP_TOKEN, FilterService } from '@beecore/core';
import { MenuService } from '@beecore/startup';
import { merge } from 'rxjs';
import { filter, map, scan } from 'rxjs/operators';
import { SFE_CONSTANTS_TOKEN } from '../tokens/sfe-constants.token';
import { ISfeConstants } from '../interfaces/i-sfe-constants';
import { SfeMenuService } from 'src/app/shared/services/sfe-menu.service';
import { SfeMenuControllerService } from 'src/app/shared/services/sfe-menu-controller.service';

export function sfeInitializer(
  menuService: MenuService,
  sfeMenuService: SfeMenuService,
  sfeMenuController: SfeMenuControllerService,
  sfeConstants: ISfeConstants,
  filterService: FilterService,
  authService: AuthService,
  loginService: LoginService,
  userService: UserService
) {

  function carregarMenu(value: { isAuth: boolean, companyId: number }) {

    if (value.isAuth &&
      value.companyId) {
      const subs = sfeMenuService.getMenus(value.companyId)
        .subscribe(x => {
          subs.unsubscribe();
          menuService.clear();
          menuService.push(...x.items);
        });
    }
  }

  function registraEventoAlteracaoMenu() {

    merge(
      authService
        .asObservable()
        .pipe(
          filter(u => !!u),
          map(isAuth => ({ isAuth }))
        ),
      filterService
        .asObservable<number>(sfeConstants.companyFilter)
        .pipe(
          filter(x => !!x),
          map(companyId => ({ companyId }))
        ),
      sfeMenuController
        .asObservable()
        .pipe(
          map(() => ({}))
        )
    )
      .pipe(
        scan((prev, value) => Object.assign(prev, value), { isAuth: false, companyId: undefined })
      )
      .subscribe(x => carregarMenu(x));
  }

  async function externalLogin() {
    const url = new URLSearchParams(location.search);

    const token = url
      .get('token');

    if (token) {
      authService.setToken(token);

      try {
        await loginService.authorize();
      } catch (error) {
        console.log(error);
      }

      if (!authService.isAuthenticated()) {
        authService.clearTokens();
      }

      if (userService.currentUser) {
        const codEmpresa = url
          .get('codEmpresa');

        if (codEmpresa) {
          filterService.set(sfeConstants.companyFilter, Number(codEmpresa));
        }
      }
    }
  }

  return async () => {
    await externalLogin();
    registraEventoAlteracaoMenu();
  };
}

export const SFE_INITIALIZER_PROVIDER: Provider = {
  provide: BC_STARTUP_TOKEN,
  useFactory: sfeInitializer,
  deps: [
    MenuService,
    SfeMenuService,
    SfeMenuControllerService,
    SFE_CONSTANTS_TOKEN,
    FilterService,
    AuthService,
    LoginService,
    UserService
  ],
  multi: true
};
